<template>
    <div class="posted-by">
        <div class="bg-light border add-rounded mt-5 px-3 pb-3">
            <h4 class="font-weight-bolder mt-4 text-left">Posted By</h4>
            <div class="row" v-if="client.Setting">
                <div class="col-4 col-md-5 col-lg-4">
                    <img :src="client.logo" alt="" class="rounded-circle img-height" />
                </div>
                <div class="col-8 col-md-7 col-lg-8 pl-3">
                    <h3 class="font-weight-bolder kova-text text-left employer-name">{{ clientName }}</h3>
                    <h6 class="font-weight-bolder text-left">{{ formatAmount(client.ProjectsPosted) }} jobs posted</h6>
                    <div class="text-left">
                        <span class="ctrl-size"><a-icon class="icon-env mb-1" type="environment" /> {{ client.Location }} </span>
                        <h6 class="font-weight-bolder text-left">{{ formatAmount(client.AmountSpent) }} spent</h6>
                    </div>
                </div>
            </div>

            <div v-else>
                  <a-skeleton active :paragraph="{ rows: 2 }" />
            </div>

            <div class="mt-4 add-rounded bg-kovatek p-4" v-if="client.Setting">
                <h5 class="font-weight-bolder text-left text-white">Verifications</h5>
                <div class="row">
                    <div class="col-4 pl-3 text-left">
                        <a-icon class="text-white icon-env mb-2" type="message" /> <br>
                    </div>

                    <div class="col-8 text-right text-white">
                        <p class="">Interviewing: 5</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4 pl-3 text-left">
                        <a-icon class="text-white icon-env mb-2" type="form" /> <br>
                    </div>
                    <div class="col-8 text-right text-white">
                        <p class="">Hired: 5 of 6 hired</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4 pl-3 text-left">
                        <a-icon class="text-white icon-env mb-2 mt-1" type="credit-card" /><br>
                    </div>
                    <div class="col-8 text-right text-white">
                        <p class="">Payment Method</p>
                    </div>
                </div>
            </div>

            <div class="mt-4 add-rounded bg-kovatek p-4" v-else>
                <h5 class="font-weight-bolder text-left text-white">Verifications</h5>
                  <a-skeleton active :paragraph="{ rows: 3 }" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'posted-by',
  props: {
    client: Object,
  },
  computed: {
    clientName() {
      if(!this.client || !this.client.Setting) return '';
      const { Surname, Firstname } = this.client.Setting;
      return `${Surname} ${Firstname}`
    }
  }
}
</script>

<style scoped>
.kova-text{
    color: #20409a;
}
.icon-size{
    font-size: 25px;
}
.btn-kovatek{
  background-color: #20409A;
  font-weight: bold;
  outline: 0;
  border: 0;
  width: 255px;
  height: 45px;
  color: #fff;
  border-radius: 30px;
  transition: .25s;
  font-size: 18px;
}
.btn-kovatek:hover{
  background-color: #06216d;
  color: #fff;
}
.bg-kovatek{
  background-color: #20409A;
}
.img-height{
    width: 90px;
    height: 90px;
}
.icon-env{
    font-size: 20px;
}
@media screen and (min-width: 992px) and (max-width: 1325px){
    
}

@media screen and (min-width: 992px) and (max-width: 1200px){
    .employer-name{
        font-size: 18px;
    } 
    .img-height{
        width: 70px;
        height: 70px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px){
   
}

@media screen and (max-width: 767px){

}
</style>